/* eslint-disable no-magic-numbers */
export default class AuditAmountDeviationFilters {
  static DEFAULT_AMOUNT = 1000;

  static LESS_THAN = "lessThan";

  static LESS_THAN_OR_EQUAL = "lessThanOrEqual";

  static GREATER_THAN = "greaterThan";

  static GREATER_THAN_OR_EQUAL = "greaterThanOrEqual";

  static EQUAL = "equal";

  static BETWEEN = "between";
}
